exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.some-class > div.dataTables_paginate {\n    text-align: right;\n}\n\n.dataTables_paginate ul {\n    position: relative;\n    float: right;\n}\n\n.dataTables_paginate input, .dataTables_paginate button {\n    display: inline-block;\n    height: 28px;\n    width: auto;\n    font-size: 13px;\n    margin: 0;\n}\n\n.dataTables_paginate form {\n    margin: 2px 5px 0 0;\n    padding: 0;\n    display: inline-block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/datatables/style.css
// module id = 1203
// module chunks = 9